import { makeStyles } from "@material-ui/core";


export const useStyles = makeStyles((theme) => ({
    card: {
        border: '1px solid rgba(0,0,0,0.25)',
        borderRadius: '3px',
        display: 'flex',
      },
      greenLine: {
        borderLeft: '9px solid #56AF31',
        paddingLeft: '10px',
        height: "100px",
      },
      content: {
        padding: '16px',
        width: '100%',
        margin: '28px 0'
      },
      CustomTitle: {
        fontFamily: theme.fonts.family.secondary,
        fontWeight: "900",
        color: "#0f5cac",
        margin:0,
        "@media (max-width: 600px)": {
          fontSize: "14px !important",
          fontWeight: "900",
          // lineHeight: "27.32px",
          // letterSpacing: "0.1em",
        },
      },
      separator: {
        margin: '0 14px 20px 14px', // Espacio horizontal entre los textos y el punto grande
        fontSize: '14px', 
      },
}));

